@let job = (job$ |async);

@let smallScreen = smallScreen$ | async;
@let mediumScreen = mediumScreen$ | async;
@let largeScreen = largeScreen$ | async;

<div id="job-page" [ngClass]="{smallScreen, mediumScreen, largeScreen}">
    @if (job) {
    <header>
        <div class="title">
            <lucide-angular name="videotape" size="44" strokeWidth="2"></lucide-angular>
            <h1>{{ job.title }}<span>#{{job.id}}</span></h1>
            @if(!smallScreen){<app-status-chip [status]="job.status"></app-status-chip>}
        </div>
        @if(smallScreen){<app-status-chip [status]="job.status"></app-status-chip>}
    </header>

    <div class="wrapper">
        <img class="thumbnail" [src]="job.thumbnail" alt="">
        <div class="data-wrapper">
            <div class="data">
                <p>ajouté le</p>
                <p>{{ job.data.created_at | date }}</p>
            </div>
            @if(!smallScreen){<div class="ver-divider"></div>}
            <div class="data">
                <p>mis à jour</p>
                <p>{{ job.data.updated_at | date}}</p>
            </div>
            @if(!smallScreen){<div class="ver-divider"></div>}
            <div class="data">
                <p>durée</p>
                <p>{{ (job.duration ?? 0) | timer }}</p>
            </div>
            @if(!smallScreen){<div class="ver-divider"></div>}
            <div class="data languages">
                from {{ job.LangFrom.name}} to {{job.LangTo.name}}
            </div>
        </div>
    </div>


    @if(jobCompleted$ | async){

    @if(videoUrl && !isLoading && !hasError){
    <!-- Lecteur vidéo -->
    <div class="video-wrapper">
        <video [src]="videoUrl" controls preload="metadata" (error)="onVideoError($event)" class="video-player">
            Votre navigateur ne supporte pas la lecture vidéo.
        </video>

        <!-- Boutons d'action -->
        <div class="video-actions">
            <app-button class="download-btn" class="download-button">
                Télécharger
            </app-button>
        </div>
    </div>
    }

    @if(isLoading){
    <div class="loading-container">
        <ng-lottie [height]="'200px'" class="loader" [options]="options"></ng-lottie>

        @if(showProgress){
        <!-- Barre de progression (si activée) -->
        <div class="progress-container">
            <div class="progress-bar">
                <div class="progress-fill" [style.width.%]="downloadProgress"></div>
            </div>
            <span class="progress-text">{{ downloadProgress }}%</span>
        </div>
        }
    </div>
    }

    <!-- Message d'erreur -->
    @if(hasError){

    <div class="error-container">
        <h3>Erreur lors du chargement</h3>
        <p>Impossible de charger la vidéo. Veuillez réessayer.</p>
        <button (click)="retryLoad(job.id)" class="retry-button">
            Réessayer
        </button>
    </div>
    }
    }
    @else {
    <div class="process-wrapper">
        <div class="stepper-wrapper">
            <app-stepper [tasks]="job.tasks"></app-stepper>
        </div>
        <div class="tasks">
            @let currentTask = job.currentTask;
            @if(job.currentTask){
            <div class="current-task" [ngStyle]="{'border': '2px solid ' + job.currentTask.statusColor}">
                <label>Current task</label>
                <div class="task-data">
                    <lucide-angular name="chevron-right"></lucide-angular>
                    <lucide-angular [name]="getIcon(currentTask)"></lucide-angular>
                    <span>{{currentTask.type}}</span>
                    <span>{{currentTask.progress ?? 0}}%</span>
                </div>
                <div class="divider"></div>
                <div class="message">{{currentTask.message}}</div>
            </div>
            }
            <app-button type="danger" class="delete-btn" (click)="openDeleteJobModal(job.id)">supprimer</app-button>
        </div>

        <div>
            @if(job.completed && resultUrl){
            <video>
                <source [attr.src]="resultUrl" [attr.type]="job.fileExtention">
            </video>
            }
        </div>
    </div>
    }


    <div class="video-container">
        <!-- Indicateur de chargement -->

    </div>

    }
</div>